export const formatRequirementDate = (date, moment) =>
    date ? moment(date).format('DD/MM/YYYY') : 'Sin fecha';

export const requirementBadgeStyle = (item) => ({
    display: 'inline-block',
    minWidth: '80px',
    padding: '4px 10px',
    borderRadius: '12px',
    backgroundColor: item && item.color ? item.color : '#777777',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: 600
});
